import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertsRoutingModule } from './alerts-routing.module';
import { AlertsComponent } from './alerts/alerts.component';
import { FormsModule } from '@angular/forms';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { TimeAgoExtendsPipe } from 'libs/portal/src/modules/tools/pipes/time-ago.pipe';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [AlertsComponent],
  imports: [CommonModule, FormsModule, CardTableModule, FiltersModule, AlertsRoutingModule, MaterialModule],
  providers: [TimeAgoExtendsPipe],
})
export class AlertsModule {}
